/* @flow */
// react
import PropTypes from 'prop-types';
import * as React from 'react';

// api
import { autoCompleteProductsForManufacturer } from 'api/forms';

// mobx
import { observer } from 'mobx-react';
import { observable } from 'mobx';

// form components
import ElectroSelectExtra from 'forms/components/inputs/ElectroSelectExtra/ElectroSelectExtra';
import ElectroTextField from 'forms/components/inputs/ElectroTextField/ElectroTextField';
import ElectroSimpleSelect from 'forms/components/inputs/ElectroSimpleSelect/ElectroSimpleSelect';

// models
import AutoCompleteModel from 'models/forms/AutoCompleteModel';

// components
import { ExpandedList } from 'components/DocumentList/DocumentList';
import AddOrRemoveButtonControl from '../../components/controls/FormControls/AddOrRemoveButtonControl';

// styles
import styles from '../AssetRequestForm.module.scss';

@observer
class AssetDetailSection extends React.Component<*> {
  @observable productModel: AutoCompleteModel = new AutoCompleteModel(
    autoCompleteProductsForManufacturer
  );

  render(): React.Element<*> {
    const productModel = this.productModel;
    const { manufacturerModel, form, field, index } = this.props;
    const fieldValues = field.values();

    return (
      <ExpandedList
        isExpanded={true}
        header={
          <React.Fragment>
            <span>
              {`Asset ${index + 1} `}{' '}
              {fieldValues.model && `(${fieldValues.manufacturer + ' - ' + fieldValues.model})`}
            </span>
            <AddOrRemoveButtonControl
              form={form}
              field={field}
              controls={{
                onDel: true,
              }}
            />
          </React.Fragment>
        }
      >
        <div className={styles['form-asset']}>
          <ElectroSelectExtra
            field={field.$('manufacturer')}
            form={form}
            formName="assetDetails"
            labelKey="name"
            props={{
              model: manufacturerModel,
              modelChild: productModel,
            }}
          />
          <ElectroSelectExtra
            field={field.$('model')}
            form={form}
            formName="assetDetails"
            labelSeparator=" - "
            labelKey={['model', 'product_group_description']}
            props={{
              model: productModel,
            }}
          />
          <ElectroSimpleSelect field={field.$('quantity')} />
          <ElectroTextField
            field={field.$('description')}
            disabled={true}
            props={{
              disabled: true,
              multiline: true,
              rows: 3,
            }}
          />
          <ElectroTextField
            field={field.$('additionalInformation')}
            props={{
              multiline: true,
              rows: 3,
            }}
          />
        </div>
      </ExpandedList>
    );
  }
}

AssetDetailSection.propTypes = {
  manufacturerModel: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  field: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

export default AssetDetailSection;
